// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-headers-align.gray-blue-accordion .mat-expansion-panel-header-description {
  justify-content: flex-end;
  align-items: right;
}
.example-headers-align.gray-blue-accordion .mat-expansion-panel-header {
  background-color: #f3f3f7;
  height: 48px !important;
}

::ng-deep .gray-blue-accordion .mat-expansion-panel-header-title {
  color: rgb(0, 143, 199);
}

.gray-blue-accordion .card-title {
  color: #008fc7;
}

::ng-deep .gray-blue-accordion .mat-expansion-panel {
  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;
  border: 1px solid #ebedf2;
}

`, "",{"version":3,"sources":["webpack://./src/app/views/users-permissions/roles-manager/roles-manager.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B","sourcesContent":[".example-headers-align.gray-blue-accordion .mat-expansion-panel-header-description {\r\n  justify-content: flex-end;\r\n  align-items: right;\r\n}\r\n.example-headers-align.gray-blue-accordion .mat-expansion-panel-header {\r\n  background-color: #f3f3f7;\r\n  height: 48px !important;\r\n}\r\n\r\n::ng-deep .gray-blue-accordion .mat-expansion-panel-header-title {\r\n  color: rgb(0, 143, 199);\r\n}\r\n\r\n.gray-blue-accordion .card-title {\r\n  color: #008fc7;\r\n}\r\n\r\n::ng-deep .gray-blue-accordion .mat-expansion-panel {\r\n  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;\r\n  border: 1px solid #ebedf2;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
